import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=46c3e429&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c3e429')) {
      api.createRecord('46c3e429', component.options)
    } else {
      api.reload('46c3e429', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=46c3e429&", function () {
      api.rerender('46c3e429', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2n58N761q7mYn/JS/comp/ImgFallback.vue"
export default component.exports